import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=3a442d68&scoped=true&"
import script from "./LocaleChanger.vue?vue&type=script&lang=js&"
export * from "./LocaleChanger.vue?vue&type=script&lang=js&"
import style0 from "./LocaleChanger.vue?vue&type=style&index=0&id=3a442d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a442d68",
  null
  
)

export default component.exports